import { Modal, Button, Group } from '@mantine/core';
import { PDFViewer, pdf } from '@react-pdf/renderer';
import type { TripProfile } from '@generated/graphql';
import type { ItineraryItem } from '@src/types/itinerary';
import ItineraryPdf from './Itinerary-pdf';
import classes from './itinerary-pdf-modal.module.css';

type Props = {
  opened: boolean;
  onClose: () => void;
  tripProfile: TripProfile | null;
  itinerary?: ItineraryItem[] | null;
  filename?: string;
};

export default function ItineraryPdfModal({
  opened,
  onClose,
  tripProfile,
  itinerary = [],
  filename = 'itinerary.pdf',
}: Props) {
  if (!tripProfile) return null;

  const buildBlob = () => pdf(<ItineraryPdf tripProfile={tripProfile} itinerary={itinerary || []} />).toBlob();

  const handleDownload = async () => {
    const blob = await buildBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename.endsWith('.pdf') ? filename : `${filename}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const handleOpenInTab = async () => {
    const blob = await buildBlob();
    window.open(URL.createObjectURL(blob), '_blank', 'noopener,noreferrer');
  };

  return (
    <Modal opened={opened} onClose={onClose} size="90%" centered title="Itinerary PDF">
      <div className={classes.container}>
        <div className={classes.viewer}>
          <PDFViewer style={{ width: '100%', height: '100%' }}>
            <ItineraryPdf tripProfile={tripProfile} itinerary={itinerary || []} />
          </PDFViewer>
        </div>

        <Group className={classes.actions}>
          <Button variant="outline" onClick={handleOpenInTab}>
            Open in new tab
          </Button>
          <Button onClick={handleDownload}>Download PDF</Button>
          <Button onClick={onClose}>Close</Button>
        </Group>
      </div>
    </Modal>
  );
}
